import { Component, inject } from '@angular/core';
import { Router, Event, NavigationEnd, RouterOutlet } from '@angular/router';
import type { IStaticMethods } from 'preline/dist';
import { init, refresh } from 'aos';
import { TranslateService } from '@ngx-translate/core';
import translationsDE from '../../public/i18n/de.json';
import translationsEN from '../../public/i18n/en.json';

declare global {
    interface Window {
        HSStaticMethods: IStaticMethods;
    }
}

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
})
export class AppComponent {
    private router: Router = inject(Router);
    private translate: TranslateService = inject(TranslateService);

    ngOnInit(): void {
        init({ once: true });

        this.translate.setTranslation('de', translationsDE);
        this.translate.setTranslation('en', translationsEN);
        this.translate.use('de');
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                setTimeout(() => {
                    window.HSStaticMethods?.autoInit();
                    refresh();
                }, 1000);
            }
        });
    }
}
